import { useState, useEffect, useRef } from 'react'
import { computePosition, autoUpdate, autoPlacement, arrow, offset } from "@floating-ui/dom";
import '../../styles/common/tooltip.scss'

const TrimTextDisplayWithHover = (props) => {
  const { dataString = 'Invalid', dataCaption = '', dataLength = 0 } = props;
  const [hover, setHover] = useState();
  const contentRef = useRef();
  const tooltipRef = useRef();
  const arrowRef = useRef();
  let showTooltipContent = (dataString.length + dataCaption.length) > dataLength ? true : false;

  useEffect(() => {
    if (hover) {
      const contentEl = contentRef.current;
      const toolTipEl = tooltipRef.current;
      const arrowEl = arrowRef.current;
      const arrowLen = arrowEl.offsetWidth;
      const floatingOffset = Math.sqrt(2 * arrowLen ** 2) / 2;
      const placement = 'bottom-start';
      autoUpdate(contentEl, toolTipEl, () => {
        computePosition(contentEl, toolTipEl, {
          placement,
          middleware: [
            offset(floatingOffset),
            autoPlacement({
              allowedPlacements: ['top-start', 'top-end', 'bottom-start', 'bottom-end'],
            }),
            arrow({ element: arrowEl })
          ]
        }).then(({ x, y, middlewareData, placement }) => {
          Object.assign(toolTipEl.style, {
            left: `${x}px`,
            top: `${y}px`
          });
          const side = placement.split("-")[0];
          const staticSide = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          }[side];

          if (middlewareData.arrow) {
            const { x } = middlewareData.arrow;
            Object.assign(arrowEl.style, {
              left: x != null ? `${x}px` : "",
              top: y != null ? `${y - 10}px` : "",
              // Ensure the static side gets unset when
              // flipping to other placements' axes.
              right: "",
              bottom: "",
              background: '#fff',
              [staticSide]: `${-arrowLen / 2}px`,
              transform: "rotate(135deg)",
            });
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hover]);
  return (
    <>
      {
        showTooltipContent ?
          <div className='textContainer' onMouseOver={() => { setHover(true); }} onMouseOut={() => setHover(false)}>
            <div className='content' ref={contentRef}>{dataCaption ? `${dataCaption}:` : ''} {dataString.substring(0,dataLength)}...</div>
            {hover && (
              <div className='tooltip' ref={tooltipRef}>{dataCaption ? `${dataCaption}:` : ''} {dataString}<div className="arrow" ref={arrowRef}></div></div>
            )}
          </div>
          :
          <div className='textContainer'>
            <div className='content'>{dataCaption ? `${dataCaption}:` : ''} {dataString}</div>
          </div>
      }
    </>
  )
}

export default TrimTextDisplayWithHover